import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import setInnerHTML from 'utils/setInnerHTML';
import Thumbnail from 'components/thumbnail';
import Link from 'components/link';
import { POST } from 'config/types/prop';
import I18n from 'components/i18n';

const SearchListViewItem = ({ item, theme }) => {
  const {
    title,
    excerpt,
    metadata: {
      featuredImageUrl,
      coauthors: [{ // Always use the first coauthor
        relativePath,
        displayName,
      }],
      link,
    },
  } = item;

  return (
    <div className={classNames(theme.wrapper, {
      [theme.noImage]: !featuredImageUrl,
    })}
    >
      {featuredImageUrl && <div className={theme.featuredImageWrapper}>
        {/* Hiding this link as we already have the same link on the header */}
        <Link aria-hidden tabIndex="-1" to={link}>
          <Thumbnail
            alt={title}
            isLazyLoading
            originalSource={featuredImageUrl}
            position={'linearListView'}
            wrapperClasses={theme.featuredImage}
          />
        </Link>
      </div>}
      <div className={theme.content}>
        <h3 className={theme.heading}>
          <Link
            to={link}
            dangerouslySetInnerHTML={setInnerHTML(title)} // eslint-disable-line react/no-danger
          />
        </h3>
        <div
          className={theme.excerpt}
          dangerouslySetInnerHTML={setInnerHTML(excerpt)} // eslint-disable-line react/no-danger
        />
        <div className={theme.author}>
          <span>
            <I18n
              field="by"
              defaultText="by"
            />
            <Link to={relativePath}> {displayName}</Link>
          </span>
        </div>
      </div>
    </div>
  );
};

SearchListViewItem.propTypes = {
  item: PropTypes.shape(POST).isRequired,
  theme: PropTypes.object.isRequired,
};

export default SearchListViewItem;
